import { useLocation, useNavigate } from "react-router-dom";
import { Home, MessageSquare, Plus, LayoutDashboard, Settings } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { profile } = useAuth();
  const isViewer = profile?.viewer && !profile?.admin && !profile?.super_admin;

  const isActive = (path: string) => location.pathname === path;

  const handleResearch = () => {
    navigate("/conversations");
  };

  const handleNew = () => {
    navigate("/research", { state: { resetChat: Date.now() }, replace: location.pathname === "/research" });
  };

  return (
    <nav className="flex h-16 items-center justify-around border-t border-border bg-card px-1 z-50 fixed bottom-0 left-0 right-0">
      {/* Home */}
      <button
        onClick={() => navigate("/home")}
        className={cn(
          "flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors",
          isActive("/home") ? "text-primary" : "text-muted-foreground"
        )}
      >
        <Home className="h-5 w-5" />
        <span>Home</span>
      </button>

      {!isViewer && (
        <>
          {/* Research */}
          <button
            onClick={handleResearch}
            className={cn(
              "flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors",
              (isActive("/conversations") || isActive("/research")) ? "text-primary" : "text-muted-foreground"
            )}
          >
            <MessageSquare className="h-5 w-5" />
            <span>Research</span>
          </button>

          {/* New – prominent center button */}
          <div className="flex flex-1 justify-center items-center">
            <button
              onClick={handleNew}
              className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg active:scale-95 transition-transform"
              aria-label="New chat"
            >
              <Plus className="h-6 w-6" />
            </button>
          </div>
        </>
      )}

      {/* Dashboards */}
      <button
        onClick={() => navigate("/dashboards")}
        className={cn(
          "flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors",
          isActive("/dashboards") ? "text-primary" : "text-muted-foreground"
        )}
      >
        <LayoutDashboard className="h-5 w-5" />
        <span>Dashboards</span>
      </button>

      {/* Settings */}
      <button
        onClick={() => navigate("/settings")}
        className={cn(
          "flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors",
          isActive("/settings") ? "text-primary" : "text-muted-foreground"
        )}
      >
        <Settings className="h-5 w-5" />
        <span>Settings</span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
